import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { api, errorMessage } from "../lib/api";
import { useMe } from "../hooks/useMe";
import { Alert, Button, Field } from "../components/Form";
import { PageHeader } from "../components/FeatureCard";
import { t } from "../lib/i18n";

export function AccountPage() {
  const { me, loading, reload } = useMe();
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  if (loading) return null;
  if (!me) return <Navigate to="/login?next=/akaun" replace />;

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const password = String(data.get("password") ?? "");
    setSaved(false);
    if (password.length < 8) return setError(t("Kata laluan sekurang-kurangnya 8 aksara."));
    if (password !== data.get("confirm")) return setError(t("Kata laluan tidak sama."));
    setBusy(true);
    setError(null);
    try {
      await api("/api/me/password", { method: "POST", json: { password } });
      form.reset();
      setSaved(true);
      reload();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-md space-y-6">
      <PageHeader art="cover/akaun" title={t("Akaun saya")} subtitle={me.email} />
      <p className="text-sm">
        {t("Lesen")}: <strong>{me.licenseActive ? t("Aktif") : t("Belum aktif")}</strong>
      </p>
      <form onSubmit={submit} className="space-y-4">
        <h2 className="text-lg font-semibold">{me.hasPassword ? t("Tukar kata laluan") : t("Tetapkan kata laluan")}</h2>
        <Field label={t("Kata laluan baharu")} name="password" type="password" required minLength={8} maxLength={128} autoComplete="new-password" hint={t("Sekurang-kurangnya 8 aksara.")} />
        <Field label={t("Sahkan kata laluan")} name="confirm" type="password" required minLength={8} maxLength={128} autoComplete="new-password" />
        {error && <Alert kind="error">{error}</Alert>}
        {saved && <Alert kind="success">{t("Kata laluan disimpan. Lain kali anda boleh log masuk dengan emel dan kata laluan.")}</Alert>}
        <Button type="submit" busy={busy} className="w-full">{t("Simpan")}</Button>
      </form>
    </div>
  );
}
